import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from "react";
import { SearchTableButton } from "../../../../utils/Constant";
import api from "../../../../utils/api";
import { AllCardAssignTableDataColumnType } from "../../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import AllCardAssignFilterHeader from "../../../../Componant/Application/Ecommerce/ProductList/AllCardAssignFilterHeader";
import {
  AllCardAssignTableAction,
  AllCardAssignTableProductName,
  AllCardAssignTableStatus,
} from "../../../../Data/Application/Ecommerce/AllCardAssign";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { SVG } from "../../../../AbstractElements";

const AllCardAssignContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [cardAssignTableDatas, setCardAssignTableDatas] = useState([]);
  const [transactionModalOpen, setTransactionModalOpen] = useState(false);
  const [transactionData, setTransactionData] = useState<any>(null);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchAllCardAssigns = async (page: number, size: number) => {
    try {
      setLoading(true);

      const response = await api.get(
        `/api/CardAssign/GetAllCardAssignPagination?pageNumber=${page}&pageSize=${size}`
      );
      console.log("Card Assign List Response:", response.data);
      if (response.status === 200) {
        setCardAssignTableDatas(
          response.data.items.map(
            (item: any): AllCardAssignTableDataColumnType => ({
              cardAssignId: item.cardAssignId,
              ticketRFIdNo: item.ticketRFIdNo,
              ticketRFIdRef: item.ticketRFIdRef,
              cardAmount: item.cardAmount,
              cardAssignDate: new Date(item.cardAssignDate)
                .toISOString()
                .split("T")[0],
              status: item.status ? "Active" : "Inactive",
              rfId: item.rfId,
              rfidCardUniqueNumber: item.rfidCardUniqueNumber,
            })
          )
        );

        // Set total record count from backend
        setTotalRows(response.data.totalCount);
      }
    } catch (error) {
      console.error("Failed to fetch booking history:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllCardAssigns(currentPage, pageSize);
  }, [currentPage, pageSize]);

  const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/CardAssign/CardAssignReturn?cardAssignId=${id}`);
      Swal.fire('Returned!', '  Card has been returned.', 'success');

      // Refresh current page data
      await fetchAllCardAssigns(currentPage, pageSize);
    } catch (error) {
      Swal.fire("Error!", "Failed to return the card.", "error");
      console.error("Returned error:", error);
    }
  };

  const handleViewTransaction = async (rfidcardno: any, assignDate: any, ticketRFIdRef: any) => {
    try {
      const response = await api.get(
        `/api/CardTransaction/GetCardTransactionByRefIdREF?RFIDCard=${rfidcardno}&assignDate=${assignDate}&TicketRFIdRef=${ticketRFIdRef}`
      );
      if (response.status === 200) {
        setTransactionData(response.data);
        setTransactionModalOpen(true);
      } else {
        Swal.fire("Error!", "Failed to fetch transaction.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "No data found.", "error");
      console.error("Transaction fetch error:", error);
    }
  };

  const allCardAssignTableDataColumn: TableColumn<AllCardAssignTableDataColumnType>[] =
    [
      {
        name: "Ticket Number",
        cell: (row) => (
          <AllCardAssignTableProductName title={row.ticketRFIdNo} />
        ),
        grow: 2,
      },
      {
        name: "Ticket ID",
        selector: (row) => `${row.ticketRFIdRef}`,
        grow: 2,
      },
      {
        name: "RFID Card No.",
        selector: (row) => `${row.rfidCardUniqueNumber}`,
        grow: 2,
      },
      {
        name: "Amount",
        selector: (row) => `${row.cardAmount}`,
      },
      {
        name: "Assign Date",
        cell: (row) => <AllCardAssignTableStatus title={row.cardAssignDate} />,
      },
      {
        name: "Status",
        cell: (row) => <AllCardAssignTableStatus title={row.status} />,
      },
      {
        name: "Action",
        cell: (row) => (
          <>
            <span
              onClick={() => handleViewTransaction(row.rfidCardUniqueNumber, row.cardAssignDate, row.ticketRFIdRef)}
              title="View Transaction"
              style={{ cursor: "pointer", marginLeft: "8px" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
              </svg>
            </span>
            <AllCardAssignTableAction
              cardAssignId={row.cardAssignId}
              onDelete={handleDelete}
            />
          </>
        ),
      },
    ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

 const filteredItems = cardAssignTableDatas.filter((item: any) => {
    if (!filterText) return true;
    const search = filterText.toLowerCase();
    return Object.values(item).some((value) =>
        value?.toString().toLowerCase().includes(search)
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilterText(e.target.value)
          }
          type="search"
          value={filterText}
        />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <AllCardAssignFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={allCardAssignTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    noDataComponent="No records found matching your search, try remove initial zero from RFID Card No. and search again."
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={transactionModalOpen}
        toggle={() => setTransactionModalOpen(false)}
        size="xl"
        style={{
          maxWidth: "90vw",
          width: "90vw",
          minHeight: "70vh",
          top: "5vh",
        }}
        contentClassName="custom-transaction-modal"
      >
        <ModalHeader
          toggle={() => setTransactionModalOpen(false)}
          style={{
            fontSize: "2rem",
            fontWeight: 700,
            borderBottom: "2px solid #eee",
            background: "#f0f4f8",
            color: "#222",
            letterSpacing: 1,
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <SVG
              iconId="credit-card"
              style={{ width: 32, height: 32, fill: "#007bff" }}
            />
            Transaction Details
          </span>
        </ModalHeader>
        <ModalBody
          style={{
            padding: "2.5rem 2rem 2rem 2rem",
            background: "#f8f9fa",
            minHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {transactionData && (
            <div style={{ marginBottom: 24, display: "flex", gap: 32, flexWrap: "wrap" }}>
              <div>
                <b>Security Amount:</b>{" "}
                <span style={{ color: "#007bff", fontWeight: 600 }}>
                  ₹{transactionData.securityAmount ?? "N/A"}
                </span>
              </div>
              <div>
                <b>Total Refund Amount:</b>{" "}
                <span style={{ color: "#28a745", fontWeight: 600 }}>
                  ₹{transactionData.totalRefundAmount ?? "N/A"}
                </span>
              </div>
              <div>
                <b>Card Available Amount:</b>{" "}
                <span style={{ color: "#ffc107", fontWeight: 600 }}>
                  ₹{transactionData.amount ?? "N/A"}
                </span>
              </div>
              <div>
                <b>Cloth Status:</b>{" "}
                <span style={{ color: transactionData.clothReturnStatus === "Returned" ? "#28a745" : "#dc3545", fontWeight: 600 }}>
                  {transactionData.clothReturnStatus ?? "N/A"}
                </span>
              </div>
              <div>
                <b>Locker Status:</b>{" "}
                <span style={{ color: transactionData.lockerReturnStatus === "Returned" ? "#28a745" : "#dc3545", fontWeight: 600 }}>
                  {transactionData.lockerReturnStatus ?? "N/A"}
                </span>
              </div>
              <div>
                <b>RFID Card No.:</b>{" "}
                <span style={{ color: "#28a745", fontWeight: 600 }}>
                  {transactionData.rfidCardNo ?? "N/A"}
                </span>
              </div>
            </div>
          )}
          {transactionData ? (
            Array.isArray(transactionData.cardTransactionReturn) ? (
              transactionData.cardTransactionReturn.length > 0 ? (
                <div className="row g-4">
                  {transactionData.cardTransactionReturn.map((txn: any, idx: number) => (
                    <div key={idx} className="col-md-6 col-lg-4 mb-4">
                      <div
                        style={{
                          background: "#fff",
                          borderRadius: 18,
                          boxShadow: "0 4px 24px #0002",
                          padding: 28,
                          height: "100%",
                          border: "1px solid #e3e6ea",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: 16,
                          }}
                        >
                          <SVG
                            iconId="file-text"
                            style={{
                              width: 22,
                              height: 22,
                              fill: "#007bff",
                              marginRight: 8,
                            }}
                          />
                          <h5
                            style={{ margin: 0, fontWeight: 700, fontSize: 18 }}
                          >
                            Transaction #{txn.transactionID}
                          </h5>
                        </div>
                        <div style={{ fontSize: 15, color: "#444" }}>
                          <p style={{ marginBottom: 8 }}>
                            <b>Type:</b> {txn.transactionType}
                          </p>
                          <p style={{ marginBottom: 8 }}>
                            <b>Amount:</b>{" "}
                            <span style={{ color: "#007bff", fontWeight: 600 }}>
                              ₹{txn.paymentAmount}
                            </span>
                          </p>
                          <p style={{ marginBottom: 8 }}>
                            <b>Status:</b>{" "}
                            <span
                              style={{
                                color:
                                  txn.paymentStatus === "Success"
                                    ? "#28a745"
                                    : "#dc3545",
                                fontWeight: 700,
                                letterSpacing: 0.5,
                              }}
                            >
                              {txn.paymentStatus}
                            </span>
                          </p>
                          <p style={{ marginBottom: 8 }}>
                            <b>Date:</b>{" "}
                            {new Date(txn.transcationDate).toLocaleString()}
                          </p>
                          <p style={{ marginBottom: 0 }}>
                            <b>Ticket Ref:</b>{" "}
                            <span style={{ color: "#6c757d" }}>
                              {txn.ticketRFIdRef}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
                  No transaction data found.
                </p>
              )
            ) : (
              <div
                style={{
                  background: "#fff",
                  borderRadius: 18,
                  boxShadow: "0 4px 24px #0002",
                  padding: 32,
                  maxWidth: 500,
                  margin: "0 auto",
                  border: "1px solid #e3e6ea",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 16,
                  }}
                >
                  <SVG
                    iconId="file-text"
                    style={{
                      width: 22,
                      height: 22,
                      fill: "#007bff",
                      marginRight: 8,
                    }}
                  />
                  <h5 style={{ margin: 0, fontWeight: 700, fontSize: 18 }}>
                    Transaction #{transactionData.cardTranscationId}
                  </h5>
                </div>
                <div style={{ fontSize: 15, color: "#444" }}>
                  <p style={{ marginBottom: 8 }}>
                    <b>Type:</b> {transactionData.transcationType}
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    <b>Amount:</b>{" "}
                    <span style={{ color: "#007bff", fontWeight: 600 }}>
                      ₹{transactionData.paymentAmount}
                    </span>
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    <b>Status:</b>{" "}
                    <span
                      style={{
                        color:
                          transactionData.paymentStatus === "Success"
                            ? "#28a745"
                            : "#dc3545",
                        fontWeight: 700,
                        letterSpacing: 0.5,
                      }}
                    >
                      {transactionData.paymentStatus}
                    </span>
                  </p>
                  <p style={{ marginBottom: 8 }}>
                    <b>Date:</b>{" "}
                    {new Date(transactionData.transcationDate).toLocaleDateString()}
                  </p>
                  <p style={{ marginBottom: 0 }}>
                    <b>Ticket Ref:</b>{" "}
                    <span style={{ color: "#6c757d" }}>
                      {transactionData.ticketRFIdRef}
                    </span>
                  </p>
                </div>
              </div>
            )
          ) : (
            <p style={{ textAlign: "center", color: "#888", fontSize: 18 }}>
              No transaction data found.
            </p>
          )}
        </ModalBody>
        <ModalFooter
          style={{ borderTop: "2px solid #eee", background: "#f0f4f8" }}
        >
          <Button
            color="secondary"
            size="lg"
            style={{
              minWidth: 120,
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 18,
            }}
            onClick={() => setTransactionModalOpen(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default AllCardAssignContainer;

/* Add this to your global CSS or in index.scss for better modal appearance:
.custom-transaction-modal {
  border-radius: 18px !important;
  box-shadow: 0 8px 32px #0002 !important;
}
*/
